<template>
    <div class="line-title">
        <div class="w-full mb-5">
            <div class="flex gap-2 flex-wrap items-center">
                <p class="text-primary text-xl mb-0 px-8 flex-1" :class="[form ? 'italic text-base font-medium':'text-lg font-semibold']">
                    <slot />
                    <span v-if="required" class="text-danger dark:text-danger">
                        *</span>
                </p>
                <div class="">
                    <slot name="action"></slot>
                </div>
            </div>
            <hr v-if="!form" class="my-2 w-full border" />
            <p v-if="subtitle" class="text-grey-400 mb-0 px-8">
                {{ subtitle }}
            </p>
        </div>
        <slot name="content"></slot>
    </div>
</template>

<script setup>
defineProps({
    subtitle: {
        type: String,
        default: null
    },
    required: {
        type: Boolean,
        default: false
    },
    form: {
        type: Boolean,
        default: false
    }
})
</script>

